import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { OuthandedSupplementaryEquipment } from '../../register-entrance-leave.model';

@Component({
    selector: 'app-outhanded-supplementary-equipment-item',
    templateUrl: './outhanded-supplementary-equipment-item.component.html',
    styleUrls: ['./outhanded-supplementary-equipment-item.component.scss'],
    standalone: false
})
export class OuthandedSupplementaryEquipmentItemComponent implements OnInit {

  @Input() supplementaryEquipment: OuthandedSupplementaryEquipment;

  @Output() changed = new EventEmitter<void>();

  formGroup = new FormGroup({
    checked: new FormControl(false, [])
  });

  constructor() { }

  ngOnInit(): void {

    this.formGroup.valueChanges.subscribe(value => {
      this.supplementaryEquipment.selected = value.checked === true;
      this.changed.next();
    });

  }

}
